import { useEffect, useState } from "react";
import {
  ANDROID_PLAY_STORE_URL,
  getMobileStoreUrl,
  IOS_APP_STORE_URL,
} from "../utils/deviceRedirect";
import schoolWellbeingLogo from "../img/swb-logo.png";

const GetTheApp = () => {
  const [storeUrl, setStoreUrl] = useState(null);

  useEffect(() => {
    const destination = getMobileStoreUrl(
      navigator.userAgent,
      navigator.maxTouchPoints,
    );
    setStoreUrl(destination);

    if (!destination) {
      return undefined;
    }

    const redirectTimeout = window.setTimeout(() => {
      window.location.assign(destination);
    }, 1000);

    return () => window.clearTimeout(redirectTimeout);
  }, []);

  return (
    <div className="flex min-h-screen items-center bg-[#f7f4f8] px-5 py-10 text-[#29212d]">
      <main className="mx-auto w-full max-w-md text-center">
        <img
          src={schoolWellbeingLogo}
          alt="School Wellbeing"
          className="mx-auto h-auto w-full max-w-[250px]"
        />
        <h1 className="mt-4 text-3xl font-bold">
          Get the School Wellbeing app
        </h1>
        <p className="mt-4 text-base leading-6 text-[#5e5864]">
          Access wellbeing support, services, and helpful tools wherever you
          are.
        </p>

        {storeUrl ? (
          <p className="mt-6 text-sm text-[#5e5864]" role="status">
            Taking you to the app store...
          </p>
        ) : (
          <p className="mt-6 text-sm text-[#5e5864]">
            Choose your device to download the app.
          </p>
        )}

        <div className="mt-8 grid gap-3">
          <a
            className="rounded-md bg-[#7b5fa6] px-5 py-3 font-semibold text-white transition hover:bg-[#5c356c]"
            href={IOS_APP_STORE_URL}
          >
            Download on the App Store
          </a>
          <a
            className="rounded-md border border-[#7b5fa6] bg-white px-5 py-3 font-semibold text-[#5c356c] transition hover:bg-[#eee8f2]"
            href={ANDROID_PLAY_STORE_URL}
          >
            Get it on Google Play
          </a>
        </div>
      </main>
    </div>
  );
};

export default GetTheApp;
